define('webshopProductsCategoriesI18n',[
  'module',
  'underscore',
  'settings'
], function (
  Module,
  _,
  Settings
) {
  'use strict';

  /**
   * Translation with a default text, for the products x categories screen
   * only: on this branch _.i18n has no default argument and returns the
   * lookup key ("<lang>.<key>") when the translation does not exist yet.
   */
  Module.exports = function (key, defaultText) {
    var text = _.i18n(key);

    if (!text || text === Settings.get('lang') + '.' + key)
      return defaultText;

    return text;
  };
});

